// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"91c795c8","55":"ae8dddb6","77":"b1f703ab","193":"237597e4","361":"c6ed2ddc","386":"bb6df933","479":"bc86e700","731":"127b45a6","963":"0bf4abd0"}[chunkId] + ".chunk.css";
};